import React from "react";
import $ from "jquery";

// import "./share_style.css";
import { imageStore, shareSuccessStore } from "../../config/store";
import {
  twitterShareLink,
  googleShareLink,
  facebookShareLink,
  whatsappShareLink,
} from "../../utils/url";
import { onSocialShareCT } from "../../utils/helper";
// import CleverTapSdk from '../CleverTapSdk';

export default class SharePopup extends React.Component {
  constructor(props) {
    super();
    this.state = {
      twitterLink: twitterShareLink,
      googleLink: googleShareLink,
      facebookLink: facebookShareLink,
      whatsappLink: whatsappShareLink,
      text: "",
      detailurl: "",
      image: "",
      open: false,
    };
  }

  componentDidMount() {
    imageStore.subscribe(() => {
      let item = imageStore.getState().data;
      let setObj = { open: false };
      if (item.text) {
        setObj["text"] = item.text;
      }
      if (item.image) {
        setObj["image"] = item.image;
      }
      if (item.detailurl) {
        setObj["detailurl"] = item.detailurl;
      }
      if (item.open) {
        setObj["open"] = true;
      }
      this.setState({ ...setObj });
    });
  }

  setClevertap = (type) => {
    shareSuccessStore.dispatch({
      type: "SET_SHARED",
      data: { shared: true },
    });
    onSocialShareCT({
      type,
      shareurl: this.state.detailurl,
      text: this.state.text,
      image: this.state.image
    });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  render() {
    let { detailurl, text } = this.state;
    let quote = text ? text.split("<br/>").join("") : "";
    let quote2 = text ? text.split("<br/>").join("\n") : "";

    var facebookLink =
      this.state.facebookLink +
      "&link=" +
      encodeURIComponent(detailurl) +
      "&quote=" +
      encodeURIComponent(quote) +
      "&www.facebook.com=1";
    var twitterLink =
      this.state.twitterLink +
      encodeURIComponent(quote2 + " \n\n " + detailurl) +
      "&www.facebook.com=1";
    var whatsappLink =
      this.state.whatsappLink +
      encodeURIComponent(quote + "  " + detailurl) +
      "&www.facebook.com=1";

    if (!this.state.open) {
      return "";
    }
    return (
      <div className="mantr6_popup">
        <div className="mantr6_popupcontent">
          <img src="/assets/img/share_kh1.png" className="share_kh1"/>
          <img src="/assets/img/bird11.png" className="share_kh2"/>
          <img
            src="/assets/img/close.png"
            className="img-fluid cross_btn"
            alt="close"
            onClick={this.handleClose}
          />
          <h4>Share and Inspire other Exam Warriors!</h4>
          <ul>
            {/* facebook */}
            <li>
              <a
                href={facebookLink}
                target="_blank"
                onClick={() => {
                  this.setClevertap("facebook");
                }}
              >
                <img
                  src="/assets/img/facebook.png"
                  className="img-fluid"
                  alt=""
                />{" "}
                Facebook
              </a>
            </li>
            {/* twitter */}
            <li>
              <a
                href={twitterLink}
                target="_blank"
                onClick={() => {
                  this.setClevertap("twitter");
                }}
              >
                <img
                  src="/assets/img/twitter.png"
                  className="img-fluid"
                  alt=""
                />{" "}
                Twitter
              </a>
            </li>
            {/* Whatsapp */}
            <li>
              <a
                href={whatsappLink}
                target="_blank"
                onClick={() => {
                  this.setClevertap("whatsapp");
                }}
              >
                <img
                  src="/assets/img/whatsapp.png"
                  className="img-fluid"
                  alt=""
                />{" "}
                Whatsapp
              </a>
            </li>
            {/* instagram */}
            {/* <li>
              <a href="#">
                <img
                  src="/assets/img/instagram.png"
                  className="img-fluid"
                  alt=""
                />{" "}
                Instagram
              </a>
            </li> */}
          </ul>
          <img
            src="/assets/img/img-15.png"
            className="img-fluid popup_img15"
            alt=""
          />
          <img
            src="/assets/img/img-14.png"
            className="img-fluid popup_img14"
            alt=""
          />
        </div>
      </div>
    );

    // old design currently ignore this
    return (
      <div
        className="popup_fixed"
        id="share_popup_box_main"
        style={{ display: "none" }}
      >
        <section className="nm_app_notification_share">
          <div className="">
            <div className="row_fluid">
              <div
                className="col-12 flt_right"
                style={{ position: "relative" }}
              >
                <h4 className="share_popup_h4">Share</h4>
              </div>
              <a
                href="javascript:void(0);"
                onClick={() => {
                  $(".popup_fixed").hide();
                }}
                className="crossbtnshare"
              >
                x
              </a>
            </div>
            <div className="share_popup_icon_wrap">
              <div className="row_fluid">
                <div className="col-12">
                  <ul
                    className="rakhi_popup"
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    {/* Facebook */}
                    <li>
                      <figure>
                        <a
                          href={facebookLink}
                          target="_blank"
                          onClick={() => {
                            this.setClevertap("facebook");
                          }}
                        >
                          <img
                            src="/images/facebook.png"
                            className="share_icons"
                          />
                          <figcaption>Facebook</figcaption>
                        </a>
                      </figure>
                    </li>
                    {/* <li><figure><a href={googleLink} target="_blank"><img src="/Assets/images/google_icon.png" className="share_icons" /><figcaption>Google</figcaption></a></figure></li> */}
                    {/* twitter */}
                    <li>
                      <figure>
                        <a
                          href={twitterLink}
                          target="_blank"
                          onClick={() => {
                            this.setClevertap("twitter");
                          }}
                        >
                          <img
                            src="/images/twitter.png"
                            className="share_icons"
                          />
                          <figcaption>Twitter</figcaption>
                        </a>
                      </figure>
                    </li>
                    {/* whatsapp */}
                    <li>
                      <figure>
                        <a
                          href={whatsappLink}
                          target="_blank"
                          onClick={() => {
                            this.setClevertap("whatsapp");
                          }}
                        >
                          <img
                            src="/images/whatsapp.png"
                            className="share_icons"
                          />
                          <figcaption>Whatsapp</figcaption>
                        </a>
                      </figure>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}
